import { createContext, useContext, useSyncExternalStore } from 'react';
import type { ReactElement, ReactNode } from 'react';
import type { SessionSnapshot, SessionStore } from './session';

const SessionContext = createContext<SessionStore | null>(null);

export function SessionProvider({ store, children }: { store: SessionStore; children?: ReactNode }): ReactElement {
  return <SessionContext.Provider value={store}>{children}</SessionContext.Provider>;
}

/** The session store and its current snapshot; re-renders when the store changes. */
export function useSession(): { store: SessionStore; snapshot: SessionSnapshot } {
  const store = useContext(SessionContext);
  if (!store) throw new Error('useSession must be used inside SessionProvider');
  const snapshot = useSyncExternalStore(store.subscribe, store.getSnapshot);
  return { store, snapshot };
}
